export function getCookieByName(name: string): string {
  const cookies = document.cookie.split(';');

  const namedCookie = cookies.find((cookie) => cookie.startsWith(`${name}=`));
  if (namedCookie) {
    return namedCookie.split('=')[1];
  }

  const builderCookie = cookies.find((cookie) =>
    cookie.startsWith(`b_${name}=`)
  );
  if (builderCookie) {
    return builderCookie.split('=')[1];
  }

  return '';
}
